import BaseModule from './BaseModule.js';

class User extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`/back-office/users`, { params: { page, per_page, term } });
  }

  async create({ name, email, role, status, is_owner }) {
    return await this.post(`/back-office/users`, {
      name,
      email,
      role,
      status,
      is_owner,
    });
  }

  async update({ id, name, email, role, status, generate_new_password, unlink, is_owner }) {
    return await this.patch(`/back-office/users/${id}`, {
      name,
      email,
      role,
      status,
      generate_new_password,
      unlink,
      is_owner,
    });
  }

  async remove(id) {
    return await this.delete(`/back-office/users/${id}`);
  }
  //
}

export default User;
